export default {
  "pcItemBtn": "Porównaj ceny",
  "pcItemCbLabel": "Kup z cashback!",
  "pcItemPriceText": "od",
}